import { Component, OnDestroy, OnInit, ViewChild } from '@angular/core';
import { Subscription } from 'rxjs/Subscription';
import { UsersService } from '../services/users.service';

@Component({
  selector: 'core-nav',
  templateUrl: './nav.component.html'
})

export class NavComponent implements OnInit, OnDestroy {
  private subscriptions: Subscription[] = [];
  isLoggedInNav: boolean;

  constructor(private usersService: UsersService) { }

  ngOnInit() {
  }

  ngOnDestroy(): void {
    this.subscriptions.forEach(s => s.unsubscribe());
  }

  receiveMessage($event) {
    this.isLoggedInNav = $event
  }

  downloadUserManual() {
    this.subscriptions.push(this.usersService.getUserManual().subscribe(q => {
    }, (err) => {
    }));
  }
}



// WEBPACK FOOTER //
// C:/Users/Pablo/source/repos/prote/angular/src/app/core/nav/nav.component.ts